import type { TaskPriority } from '../types/taskRequest';

interface TaskPriorityBadgeProps {
  priority: TaskPriority;
  display?: string;
}

const priorityConfig: Record<TaskPriority, { label: string; className: string }> = {
  1: { label: 'Low', className: 'task-priority-badge task-priority-low' },
  2: { label: 'Normal', className: 'task-priority-badge task-priority-normal' },
  3: { label: 'High', className: 'task-priority-badge task-priority-high' },
  4: { label: 'Urgent', className: 'task-priority-badge task-priority-urgent' },
};

export default function TaskPriorityBadge({ priority, display }: Readonly<TaskPriorityBadgeProps>) {
  const config = priorityConfig[priority] ?? priorityConfig[2];
  return (
    <span className={config.className}>
      {display ?? config.label}
    </span>
  );
}
